<template>
  <div class="garage-price-list-header">
    <div class="garage-price-list-header__container">
      <NuxtImg
        v-if="garageImage[0]"
        class="hide-on-mobile"
        width="92px"
        height="66px"
        :src="`${garageImage[0]?.url}`"
        :alt="`${garage.name}`"
      />
      <div class="garage-price-list-header__wrapper">
        <div class="garage-price-list-header__name">{{ garage.name }}</div>

        <div class="garage-price-list-header__rating">
          <div class="garage-price-list-header__rating-stars">
            <NuxtImg
              v-for="(item, index) in 6"
              width="18px"
              height="18px"
              class="garage-price-list-header__rating-star"
              alt="Ocena DobryMechanik.pl"
              :src="getStar(garage.ratingTotal || 0, index).toString()"
            />
          </div>
          <span class="garage-price-list-header__rating-total">{{ garage.ratingTotal }}</span>

          <span class="garage-price-list-header__total-comments">
            ({{ totalComments }} {{ getCommentsTranslatePL(totalComments) }})
          </span>
        </div>

        <div>
          <p class="garage-price-list-header__address">
            {{ garage.address }}, {{ garage.quarter }}<span v-if="garage.quarter">, </span>{{ garage.city }}
          </p>
        </div>
      </div>
    </div>

    <template v-if="basketAB">
      <div class="hide-on-mobile">
        <div class="garage-price-list-header__add-notes-wrapper">
          <button
            @click.prevent="emits('open-modal')"
            class="garage-calendar-page__footer-ab-button"
          >
            <div class="garage-calendar-page__footer-ab-button-wrapper">
              <div class="garage-calendar-page__footer-ab-button-title">
                Dodaj usługę do zlecenia <span> (opcjonalnie)</span>
              </div>
              <div class="garage-calendar-page__footer-ab-button-subtitle">np. Proszę dodatkowo o wymianę oleju</div>
            </div>

            <i class="i-circle-add" />
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { getStar } from '@/helpers/get-star';
import { DmButton } from '@dobrymechanik/vue-ui-v2';
import type { GarageImageJsonldGarageImageRead, GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead } from '~/api/docs/api';
import { getCommentsTranslatePL } from '~/helpers/helpers';

interface IProps {
  garage: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  totalComments: number;
  garageImage: GarageImageJsonldGarageImageRead[];
  basketAB?: boolean;
  abContent?: string;
}

interface IEmits {
  (name: 'open-modal'): void;
}

// props
const props = defineProps<IProps>();

// emits
const emits = defineEmits<IEmits>();

// use
const route = useRoute();
</script>

<style scoped lang="scss">
.garage-price-list-header {
  background-color: $grey-6;
  margin: 0 -14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;

  @media (min-width: $breakpoint) {
    margin: 0;
    width: 100%;
    min-width: 376px;
    background-color: unset;
    border: 1px solid $grey-4;
    border-radius: 10px;
    gap: 10px;
    padding: 20px;
    align-items: stretch;
  }

  &__container {
    display: flex;
    gap: 10px;
  }


  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 2px;

    @media (min-width: $breakpoint) {
      align-items: flex-start;
      gap: 4px;
    }
  }

  &__name {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    text-align: center;

    @media (min-width: $breakpoint) {
      font-size: 16px;
      text-align: left;
    }
  }

  &__address {
    color: $grey-2;
    font-size: 14px;
    line-height: 22px;
    margin: 0;

    a {
      text-decoration: underline;
    }
  }

  &__rating {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0 8px;
  }

  &__rating-star {
    &:not(:last-child) {
      margin-right: 2px;
    }
  }

  &__rating-total {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
  }

  &__total-comments {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: $blue-1;
  }

  &__add-notes-wrapper {
    border-top: 1px solid $grey-4;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 10px;
    margin-top: 10px;
  }
}


// abtest
.garage-calendar-page__confirm-button-ab {
  border-top: 1px solid $grey-4;
  padding-top: 14px;
  margin-top: 14px;

  @media (min-width: $breakpoint) {
    border-top: unset;
    padding-top: unset;
    margin-top: unset;
  }
}

.garage-calendar-page__footer-ab-button {
  display: flex;
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 16px;
  padding: 4px 0;
  cursor: pointer;

  i {
    background: $blue-1;
  }
}

.garage-calendar-page__footer-ab-button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.garage-calendar-page__footer-ab-button-title {
  span {
    color: $grey-2;
  }
}

.garage-calendar-page__footer-ab-button-subtitle {
  color: $grey-2;
  font-size: 14px;
}
</style>
